import styled from "styled-components";

export const ModalBackdrop = styled("div")(({ open }) => {
  return {
    display: open ? "block" : "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backdropFilter: "blur(3px)",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    zIndex: 999,
    pointerEvents: "auto",
  };
});

export const EmployeeBulkUploadModalWrapper = styled("form")(() => {
  return {
    overflow: "hidden",
    backgroundColor: "var(--color-background)",
    padding: "var(--cardPadding)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "calc(var(--flexGap))",
    minHeight: "auto",
    "& legend": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "24px",
      textAlign: "center",
      marginBlock: "0 cal(var(--sectionMargin)/1.5)",
      paddingInline: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "&  input": {
      padding: "calc(var(--cardPadding) / 2) calc(var(--cardPadding) / 2)",
      marginTop: "0.45rem",
      outline: "none",
      border: "1px solid var(--color-primary-hover)",
      backgroundColor: "var(--color-button-secondary)",
      borderRadius: "8px",
      fontWeight: "400",
      cursor: "pointer",
    },
    "& fieldset": {
      flex: 1,
      overflow: "hidden",
    },
    "& .modal-header>p": {
      textAlign: "center",
    },
    "& .submit-button-area": {
      overflow: "hidden",
    },
    "& .close-modal-button-area": {
      overflow: "hidden",
      "& .close-modal-button": {
        width: "fit-content",
      },
      "@media screen and (min-width: 768px)": {
        display: "none",
      },
    },
    "@media screen and (min-width: 768px)": {
      height: "auto",
      "& legend": {
        fontSize: "32px",
      },
    },
  };
});
